import { fetcher_default } from "./chunk-GONJSORR.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/services/searchLocation.ts

var searchLocation_exports = {};

__export(searchLocation_exports, {
  getSearchLocation: function getSearchLocation() {
    return _getSearchLocation;
  }
});

var _getSearchLocation = function _getSearchLocation(payload) {
  var provider = payload.provider;

  if (provider === "google") {
    return fetcher_default.getSearchGoogleLocationApi("/place/nearbysearch/json", payload);
  } else {
    return fetcher_default.getSearchAmapLocationApi("/place/around", payload);
  }
};

export { _getSearchLocation as getSearchLocation, searchLocation_exports };